export interface RealEstateProperty {
  id: string;
  code: string;
  slug: string;
  title: string;
  description: string;
  type: 'Apartamento' | 'Casa' | 'Cobertura' | 'Sala Comercial' | 'Ponto Comercial' | 'Galpão';
  purpose: 'Aluguel' | 'Venda' | 'Ambos';
  priceVenda?: number;
  priceAluguel?: number;
  condoFee?: number;
  iptuFee?: number;
  insuranceFee?: number;
  totalMonthlyCost?: number;
  pricePerM2?: number;
  areaUtil: number;
  areaTotal?: number;
  bedrooms: number;
  bathrooms: number;
  parking: number;
  furnished: 'Mobiliado' | 'Sem mobília' | 'Semi-mobiliado';
  amenities: string[];
  condoAmenities: string[];
  location: {
    address: string;
    neighborhood: string;
    city: string;
    state: string;
  };
  images: string[];
  videoUrl?: string;
  featured: boolean;
  isNew?: boolean;
  isOpportunity?: boolean;
  status: 'Disponível' | 'Reservado' | 'Alugado' | 'Vendido';
}

export interface LaunchProject {
  id: string;
  title: string;
  tagline: string;
  builder: string;
  city: string;
  neighborhood: string;
  deliveryDate: string;
  status: 'Lançamento' | 'Em Obras' | 'Pronto para Morar';
  minPrice: number;
  areaRange: string;
  bedroomRange: string;
  heroImage: string;
  images: string[];
  floorPlans: { title: string; area: string; bedrooms: string; image: string }[];
  highlights: string[];
}

export const imobiliariaDataset: RealEstateProperty[] = [
  {
    id: 'prop_4868',
    code: '#4868',
    slug: 'apartamento-mobiliado-churrasqueira-esplanada',
    title: 'Apartamento 60m² com 2 quartos no bairro Esplanada',
    description: 'Excelente apartamento totalmente mobilado com churrasqueira a carvão na sacada. Ampla sala de estar integrada, cozinha sob medida e ótima posição solar. Pronto para morar em Chapecó.',
    type: 'Apartamento',
    purpose: 'Aluguel',
    priceAluguel: 2022.00,
    condoFee: 240.00,
    iptuFee: 62.00,
    insuranceFee: 0.00,
    totalMonthlyCost: 2324.00,
    pricePerM2: 33.70,
    areaUtil: 60,
    bedrooms: 2,
    bathrooms: 1,
    parking: 1,
    furnished: 'Mobiliado',
    amenities: ['Sacada com Churrasqueira', 'Cozinha Sob Medida', 'Ar Condicionado', 'Piso Laminado', 'Área de Serviço'],
    condoAmenities: ['Elevador Social', 'Salão de Festas', 'Portaria Eletrônica', 'Gás Encanado'],
    location: {
      address: 'Rua Jardim Europa, 2115D',
      neighborhood: 'Esplanada',
      city: 'Chapecó',
      state: 'SC'
    },
    images: [
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1484154218962-a197022b5858?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=800&auto=format&fit=crop'
    ],
    featured: true,
    isNew: false,
    isOpportunity: true,
    status: 'Disponível'
  },
  {
    id: 'prop_4891',
    code: '#4891',
    slug: 'apartamento-58m2-2-quartos-santo-antonio',
    title: 'Apartamento 58m² com 2 quartos no bairro Santo Antônio',
    description: 'Apartamento novo de 58m² com 2 quartos e 1 banheiro, localizado no bairro Santo Antônio em Chapecó. A unidade conta com área privativa bem distribuída, excelente iluminação natural e vaga coberta privativa.',
    type: 'Apartamento',
    purpose: 'Aluguel',
    priceAluguel: 1595.51,
    condoFee: 380.00,
    iptuFee: 62.50,
    insuranceFee: 0.00,
    totalMonthlyCost: 2038.00,
    pricePerM2: 27.51,
    areaUtil: 58,
    bedrooms: 2,
    bathrooms: 1,
    parking: 1,
    furnished: 'Sem mobília',
    amenities: ['Imóvel Novo', 'Sacada com Churrasqueira', 'Aquecimento a Gás', 'Vaga Individual'],
    condoAmenities: ['Edifício Novo', 'Elevador', 'Salão de Festas', 'Hall de Entrada Decorado', 'Gás Encanado'],
    location: {
      address: 'Rua Pernambuco, 726-D',
      neighborhood: 'Santo Antônio',
      city: 'Chapecó',
      state: 'SC'
    },
    images: [
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1513694203232-719a280e022f?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1507089947368-19c1da9775ae?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?q=80&w=800&auto=format&fit=crop'
    ],
    featured: true,
    isNew: true,
    isOpportunity: false,
    status: 'Disponível'
  },
  {
    id: 'prop_4996',
    code: '#4996',
    slug: 'sala-comercial-300m2-centro-chapecó',
    title: 'Sala Comercial de 300m² no Centro em Chapecó',
    description: 'Ampla sala comercial térrea com pé direito duplo e fachada em pele de vidro no coração de Chapecó. Ideal para agências bancárias, escritórios corporativos ou clínicas médicas.',
    type: 'Sala Comercial',
    purpose: 'Aluguel',
    priceAluguel: 5618.00,
    condoFee: 100.00,
    iptuFee: 150.00,
    totalMonthlyCost: 5868.00,
    pricePerM2: 18.72,
    areaUtil: 300,
    bedrooms: 0,
    bathrooms: 3,
    parking: 4,
    furnished: 'Sem mobília',
    amenities: ['Pé Direito Duplo', 'Fachada de Vidro', 'Acessibilidade PWD', 'Copa'],
    condoAmenities: ['Estacionamento Rotativo', 'Gerador de Energia'],
    location: {
      address: 'Rua Clevelândia, 150-E',
      neighborhood: 'Centro',
      city: 'Chapecó',
      state: 'SC'
    },
    images: [
      'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1497215728101-856f4ea42174?q=80&w=800&auto=format&fit=crop'
    ],
    featured: true,
    isNew: true,
    isOpportunity: true,
    status: 'Disponível'
  },
  {
    id: 'prop_4997',
    code: '#4997',
    slug: 'casa-80m2-2-quartos-bairro-paraiso',
    title: 'Casa de 80m² e 2 quartos no bairro Paraíso',
    description: 'Residência térrea individual com amplo quintal ensolarado e muro privativo. Ótima ventilação cruzada, cozinha integrada e vaga coberta.',
    type: 'Casa',
    purpose: 'Aluguel',
    priceAluguel: 2359.55,
    iptuFee: 75.00,
    totalMonthlyCost: 2434.55,
    pricePerM2: 29.49,
    areaUtil: 80,
    bedrooms: 2,
    bathrooms: 1,
    parking: 2,
    furnished: 'Sem mobília',
    amenities: ['Quintal Privativo', 'Portão Eletrônico', 'Área de Churrasqueira'],
    condoAmenities: [],
    location: {
      address: 'Rua das Palmeiras, 88',
      neighborhood: 'Paraíso',
      city: 'Chapecó',
      state: 'SC'
    },
    images: [
      'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1570129477492-45c003edd2be?q=80&w=800&auto=format&fit=crop'
    ],
    featured: false,
    isNew: false,
    isOpportunity: true,
    status: 'Disponível'
  },
  {
    id: 'prop_5010',
    code: '#5010',
    slug: 'cobertura-duplex-frente-mar-balneario',
    title: 'Cobertura Duplex 450m² com 4 suítes e piscina privativa',
    description: 'Magnífica cobertura duplex de altíssimo padrão com vista panorâmica para o oceano. Design autoral, acabamentos em mármore calacatta importado e piscina aquecida privativa.',
    type: 'Cobertura',
    purpose: 'Venda',
    priceVenda: 12500000.00,
    condoFee: 2800.00,
    iptuFee: 650.00,
    pricePerM2: 27777.00,
    areaUtil: 450,
    bedrooms: 4,
    bathrooms: 5,
    parking: 4,
    furnished: 'Mobiliado',
    amenities: ['Piscina Borda Infinita', 'Adega Climatizada', 'Automação Lutron', 'Espaço Gourmet'],
    condoAmenities: ['Heliponto H homologado', 'Portaria 24h Blindada', 'Spa com Sauna', 'Academia Technogym'],
    location: {
      address: 'Av. Atlântica, 3200',
      neighborhood: 'Centro',
      city: 'Balneário Camboriú',
      state: 'SC'
    },
    images: [
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=800&auto=format&fit=crop'
    ],
    featured: true,
    isNew: true,
    isOpportunity: false,
    status: 'Disponível'
  }
];

export const launchProjectsData: LaunchProject[] = [
  {
    id: 'launch_ambar',
    title: 'Residencial Ámbar',
    tagline: 'A evolução da arquitetura contemporânea no Centro de Chapecó',
    builder: 'Macodesc Construtora',
    city: 'Chapecó',
    neighborhood: 'Centro',
    deliveryDate: 'Dezembro / 2027',
    status: 'Lançamento',
    minPrice: 890000.00,
    areaRange: '112 m² a 245 m²',
    bedroomRange: '3 Suítes',
    heroImage: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=1200&auto=format&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?q=80&w=800&auto=format&fit=crop'
    ],
    floorPlans: [
      { title: 'Planta Tipo A - 3 Suítes', area: '142 m²', bedrooms: '3 Suítes', image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=600' },
      { title: 'Planta Penthouse Duplex', area: '245 m²', bedrooms: '4 Suítes', image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=600' }
    ],
    highlights: [
      'Piscina Aquecida no Rooftop com Vista Panorâmica',
      'Manta com Isolamento Acústico entre os Pavimentos',
      'Carregamento Elétrico Individual para Carros por Vaga',
      'Gerador de Energia para Áreas Comuns e Elevadores'
    ]
  }
];
